import _ from 'lodash';

export const USER_MANAGEMENT_PAGE = 'settings/user-management';
export const INTERGRATION_USER_MANAGEMENT_PAGE = 'integration-settings/user-management';

const routePermissions = {
  [USER_MANAGEMENT_PAGE]: 'workspaceManagement.userManagement',
  [INTERGRATION_USER_MANAGEMENT_PAGE]: 'workspaceManagement.userManagement'
}

export default class userRoleService {

  static initialise(workspace, callback) {
    this.userRole = workspace.userRoles ? workspace.userRoles[0] : {};

    if(callback) {
      callback();
    }
  }

  static canCreateStoryboard() {
    return _.get(this.userRole, 'workspaceManagement.createStoryBoards', false);
  }

  static canManageUsers() {
    return _.get(this.userRole, 'workspaceManagement.userManagement', false);
  }

  static requirePermission(path, profile) {
    var userRole = profile && profile.userRoles ? profile.userRoles[0] : {};
    var access = routePermissions[path];

    if (!access) {
      return true
    }

    return _.get(userRole, access, false)
  }
}